import { NgModule, ModuleWithProviders, SkipSelf, Optional, NgModuleRef, InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiConfigManager, ApiConfigOptions, ModuleSourceInfo } from '@sg/api/base-api-lib';
import { CurrenciesApiClient, ExchangeRatesApiClient } from './services';
import { CurrenciesApiConfig } from './api-config';

declare module '../../../base-api-lib/src/lib/api-config-manager' {
  interface ApiConfigOptionsStore {
    currenciesApiConfig?: ApiConfigOptions;
  }
  interface ApiConfigManager {
    currenciesApiConfig: CurrenciesApiConfig;
  }
}

export const CONFIG_FACTORY_TOKEN = new InjectionToken('CurrenciesApiModule Config Factory');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [CurrenciesApiClient, ExchangeRatesApiClient],
})
export class CurrenciesApiModule {
  public static forRoot(
    configFactory?: (cfgMgr?: ApiConfigManager) => CurrenciesApiConfig
  ): ModuleWithProviders<CurrenciesApiModule> {
    return {
      ngModule: CurrenciesApiModule,
      providers: [{ provide: CONFIG_FACTORY_TOKEN, useValue: configFactory }],
    };
  }

  constructor(
    cfgMgr: ApiConfigManager,
    moduleRef: NgModuleRef<any>,
    @Optional() @SkipSelf() parentModule: CurrenciesApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CurrenciesApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }

    const configFactory: (cfgMgr?: ApiConfigManager) => CurrenciesApiConfig =
      moduleRef.injector.get<any>(CONFIG_FACTORY_TOKEN);
    const config = configFactory
      ? configFactory(cfgMgr)
      : new CurrenciesApiConfig(cfgMgr.withBase(cfgMgr.getRawConfig('currenciesApiConfig')));
    cfgMgr.addApiConfig('currenciesApiConfig', config);
  }
}
